var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: "position:absolute;right:10px;top:-3px;" + _vm.style_str },
    [_c("img", { ref: "help_img", attrs: { src: _vm.help_img } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }